import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './checkbox.css'
import checkIcon from '../../../images/check-rounded-green.svg'

/**
 * Modern checkbox component with custom styling
 */
const Checkbox = forwardRef(({
  label,
  error,
  checked,
  onChange,
  onBlur,
  onClick,
  disabled,
  name,
  className = '',
  ...rest
}, ref) => {
  const hasError = Boolean(error && error.length)

  const handleChange = (e) => {
    onChange?.(e)
    onClick?.(e)
  }

  const checkboxClass = [
    styles.fieldWrapper,
    hasError && styles.checkboxError,
    disabled && styles.checkboxDisabled,
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={checkboxClass}>
      <label className={styles.checkboxLabel}>
        <input
          ref={ref}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
          className={styles.checkboxInput}
          {...rest}
        />

        <span className={styles.checkboxIndicator}>
          {checked && (
            <img
              src={checkIcon}
              alt=""
              className={styles.checkIcon}
            />
          )}
        </span>

        <span className={styles.checkboxLabelText}>
          {label}
        </span>
      </label>

      {hasError && (
        <span className={classnames(styles.errorMessage, styles.errorMessageAlignLeft)}>
          {error}
        </span>
      )}
    </div>
  )
})

Checkbox.propTypes = {
  label: PropTypes.node.isRequired,
  error: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default Checkbox
